var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{attrs:{"title":"Segurança🙌"}},[_c('b-card-text',[_vm._v("This is your second page.")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }